module.exports = __webpack_public_path__ + "img/20190828162145928.1f0f7ec5.jpg";